module.exports = __webpack_public_path__ + "img/leicester-city-logo-icon.5fc0794a.png";